/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const DELETE_ALL_COMPONENT_VERSIONS_DATA_IDS = {
  cancelButton: 'delete-all-component-versions-cancel-button',
  deleteButton: 'delete-all-component-versions-delete-button',
  modalError: 'delete-all-component-versions-error',
};
